import React, { useState } from "react";

const DAYS = [
  { idx: 0, label: "Mon" }, { idx: 1, label: "Tue" }, { idx: 2, label: "Wed" },
  { idx: 3, label: "Thu" }, { idx: 4, label: "Fri" }, { idx: 5, label: "Sat" }, { idx: 6, label: "Sun" },
];

export default function AvailabilityPicker({ availability = [], blackoutDates = [], onChange }) {
  const byDay = {};
  (availability || []).forEach((a) => { byDay[a.day] = a; });

  const setDay = (idx, patch) => {
    const next = { ...byDay, [idx]: { day: idx, start: "09:00", end: "17:00", ...byDay[idx], ...patch } };
    if (patch.closed) delete next[idx];
    const arr = Object.values(next).map(({ closed, ...rest }) => rest);
    onChange({ availability: arr, blackout_dates: blackoutDates });
  };

  const [holiday, setHoliday] = useState("");
  const addHoliday = () => {
    if (!holiday) return;
    if (blackoutDates.includes(holiday)) { setHoliday(""); return; }
    onChange({ availability, blackout_dates: [...blackoutDates, holiday].sort() });
    setHoliday("");
  };
  const removeHoliday = (d) => {
    onChange({ availability, blackout_dates: blackoutDates.filter((x) => x !== d) });
  };

  const inputStyle = { borderColor: "var(--gf-border-strong)", color: "var(--gf-text)" };

  return (
    <div className="sm:col-span-2 rounded-xl border p-4" style={{ borderColor: "var(--gf-border)", background: "var(--gf-surface-2)" }} data-testid="availability-picker">
      <div className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--gf-accent)" }}>Weekly hours</div>
      <p className="text-xs mt-1" style={{ color: "var(--gf-text-muted)" }}>Toggle the days you're open and set your hours. Days left off are closed.</p>
      <div className="mt-3 space-y-2">
        {DAYS.map((d) => {
          const cur = byDay[d.idx];
          const open = !!cur;
          return (
            <div key={d.idx} className="flex items-center gap-3 text-sm">
              <label className="inline-flex items-center gap-2 w-20 cursor-pointer" data-testid={`day-toggle-${d.idx}`}>
                <input type="checkbox" checked={open} onChange={(e) => setDay(d.idx, e.target.checked ? {} : { closed: true })} style={{ accentColor: "var(--gf-accent)" }} />
                <span style={{ color: "var(--gf-text)" }}>{d.label}</span>
              </label>
              {open ? (
                <>
                  <input type="time" value={cur.start} onChange={(e) => setDay(d.idx, { start: e.target.value })}
                    className="border rounded-md px-2 py-1 bg-transparent text-sm" style={inputStyle} data-testid={`start-${d.idx}`} />
                  <span style={{ color: "var(--gf-text-muted)" }}>–</span>
                  <input type="time" value={cur.end} onChange={(e) => setDay(d.idx, { end: e.target.value })}
                    className="border rounded-md px-2 py-1 bg-transparent text-sm" style={inputStyle} data-testid={`end-${d.idx}`} />
                </>
              ) : (
                <span className="text-xs" style={{ color: "var(--gf-text-muted)" }}>Closed</span>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-5 border-t pt-4" style={{ borderColor: "var(--gf-border)" }}>
        <div className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--gf-accent)" }}>Holiday / closed dates</div>
        <p className="text-xs mt-1" style={{ color: "var(--gf-text-muted)" }}>Block specific dates (holidays, vacation). Customers won't be able to book on these days.</p>
        <div className="mt-2 flex gap-2 items-center">
          <input type="date" value={holiday} onChange={(e) => setHoliday(e.target.value)}
            className="border rounded-md px-2 py-1 bg-transparent text-sm" style={inputStyle} data-testid="holiday-date-input" />
          <button type="button" onClick={addHoliday} className="text-xs rounded-full px-3 py-1.5 font-medium" style={{ background: "var(--gf-accent)", color: "var(--gf-on-accent)" }} data-testid="add-holiday-btn">Add</button>
        </div>
        {blackoutDates.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-1.5">
            {blackoutDates.map((d) => (
              <span key={d} className="inline-flex items-center gap-1 text-xs rounded-full border px-2 py-1" style={{ borderColor: "var(--gf-border-strong)", color: "var(--gf-text)" }} data-testid={`holiday-${d}`}>
                {d}
                <button type="button" onClick={() => removeHoliday(d)} className="opacity-60 hover:opacity-100">×</button>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
